import { Ref } from "react";

import { DDQForm, FormConfig } from "../types";
import FormSection, { Mode } from "./FormSection";

export type Props = {
  register?: () => Ref<any>;
  form: DDQForm;
  mode: Mode;
};

export default function EntityDetailsFormSection({ register, mode, form }: Props) {
  const formConfig: FormConfig = {
    fullLegalName: {
      type: "text",
      label: "1A. Full legal name",
    },
    doingBusinessAsDBA: {
      type: "text",
      label: "1B. Doing business as (dba) name",
    },
    fullLegalRegisteredAddress: {
      type: "text",
      label: "1C. Full legal (registered) address",
    },
    fullPrimaryBusinessAddress: {
      type: "text",
      label: "1D. Full primary business address (if different from registered address above)",
    },
    dateOfIncorporation: {
      type: "text",
      label: "1E. Date of entity incorporation / establishment",
    },
    incorporationNumber: {
      type: "text",
      label: "1F. Incorporation number",
    },
    entityIdentifier: {
      type: "text",
      label: "1G. Entity identifier (e.g., legal entity identifier, employer identification number), if available",
    },
  };

  return (
    <FormSection
      mode={mode}
      title="Section 1. Entity Details"
      formConfig={formConfig}
      register={register}
      form={form}
    />
  );
}
